import { normalizeSearchString } from '~/utils/sanitize'

const typoTolerance = (token: string): number => {
  if (token.length < 4) return 0
  if (token.length < 8) return 1
  return 2
}

const levenshtein = (a: string, b: string): number => {
  if (a === b) return 0
  if (!a.length) return b.length
  if (!b.length) return a.length

  const previous = Array.from({ length: b.length + 1 }, (_, index) => index)
  const current = Array.from({ length: b.length + 1 }, () => 0)

  for (let i = 1; i <= a.length; i++) {
    current[0] = i
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1
      const deletion = previous[j] ?? 0
      const insertion = current[j - 1] ?? 0
      const substitution = previous[j - 1] ?? 0
      current[j] = Math.min(deletion + 1, insertion + 1, substitution + cost)
    }
    for (let j = 0; j <= b.length; j++) {
      previous[j] = current[j] ?? 0
    }
  }

  return previous[b.length] ?? 0
}

const foldSearchString = (value: string): string =>
  normalizeSearchString(value)
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()

export const matchesSearch = (
  query: string,
  ...values: Array<string | undefined>
): boolean => {
  const needle = foldSearchString(query)
  if (!needle) return true

  const haystack = foldSearchString(
    values.filter((value): value is string => Boolean(value)).join(' ')
  )
  if (haystack.includes(needle)) return true
  if (haystack.replace(/\s+/g, '').includes(needle.replace(/\s+/g, ''))) {
    return true
  }

  const queryTokens = needle.split(/\s+/).filter(Boolean)
  const hayTokens = haystack.split(/\s+/).filter(Boolean)

  return queryTokens.every((token) =>
    hayTokens.some(
      (hay) =>
        hay.includes(token) || levenshtein(token, hay) <= typoTolerance(token)
    )
  )
}
